import {
  DROPDOWN_SIZE,
  Dropdown,
  DropdownButton,
  DropdownMenu,
  DropdownMenuItem,
  useToast,
} from '@repo/design-system/index'
import { QIcon_star_filled } from '@repo/icons/index'
import { useEffect, useState } from 'react'
import { useEventTracking } from '../../../../../helpers/gtmHelper'
import { useJobOptions } from '../../../../../modules/apis/student/lesson'
import useIsWebview from '../../../../../modules/hooks/common/useIsWebview'
import { n_ai_analysis } from '../../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { COLORS } from '../../../../../modules/vars'
import TooltipNew from '../../../../_legacy/TooltipNew'

interface JobFilterSectionProps {
  selectedJobId: number
  setSelectedJobId: React.Dispatch<React.SetStateAction<number>>
  userJobId: number
}

const JobFilterSection = ({ selectedJobId, setSelectedJobId, userJobId = 9 }: JobFilterSectionProps): JSX.Element => {
  const { t } = useTranslation()
  const isWebview = useIsWebview()
  const { toastError, toastInfo } = useToast()

  const { data: options, isLoading } = useJobOptions()
  const { sendClickEvent } = useEventTracking()

  // 내가 선택한 Job
  const [option1, setOption1] = useState(null)
  const [option2, setOption2] = useState(null)
  const [option3, setOption3] = useState(null)

  useEffect(() => {
    if (option1) {
      setSelectedJobId(option1?.value)
    }
  }, [option1])

  useEffect(() => {
    if (options) {
      const list1 = options.job.map((item) => ({ label: item.title, value: item.id }))
      const list2 = options.job_year.map((item) => ({ label: item.title, value: item.id }))
      const list3 = options.job_type.map((item) => ({ label: item.title, value: item.id }))

      setOption1(list1.find((item, i) => item.value == selectedJobId))
      setOption2(list2[0])
      setOption3(list3[0])
    }
  }, [options, selectedJobId])

  const getTransformForDropdown = (options) => {
    return options.map((item) => ({ label: item.title, value: item.id }))
  }

  const clickHandler = () => {
    if (isWebview) {
      toastInfo(t(n_ai_analysis.side_menu_tooltip), {
        type: 'default',
        className: `bg-gray-100`,
        bodyClassName: `m-auto text-center `,
      })
    }
  }

  const onSelectionChange = (value) => {
    setOption1(value)
    sendClickEvent({ button_name: 'ai_analysis_job_segment_dropdown', object_title: value?.value })
  }

  if (isLoading || !options) return <></>

  return (
    <div className="z-[5] flex flex-row gap-[8px]">
      {/* 직군 */}
      <Dropdown
        selected={option1}
        setSelected={(value) => {
          onSelectionChange(value)
        }}
        className="w-full max-w-[140px]"
        size={DROPDOWN_SIZE.LG}
      >
        <DropdownButton>{option1?.label}</DropdownButton>
        <DropdownMenu>
          {getTransformForDropdown(options.job).map((item, i) => {
            return (
              <DropdownMenuItem key={i} value={item.value} className="flex flex-row items-center gap-[4px]">
                <span>{item.label}</span>
                <span>
                  {item.value === userJobId && (
                    <QIcon_star_filled color={COLORS.PURPLE500} className="h-[16px] w-[16px]" />
                  )}
                </span>
              </DropdownMenuItem>
            )
          })}
        </DropdownMenu>
      </Dropdown>
      {/* 연차 */}
      <div id="job-analaysis-1" onClick={clickHandler}>
        <Dropdown className="max-w-[84px]" disabled selected={option2} setSelected={setOption2} size={DROPDOWN_SIZE.LG}>
          <DropdownButton inactive>{t(n_ai_analysis.job_seg_popup.dropdown1)}</DropdownButton>
          <DropdownMenu>
            {getTransformForDropdown(options.job_year).map((item, i) => {
              return (
                <DropdownMenuItem key={i} value={item.id}>
                  {item.label}
                </DropdownMenuItem>
              )
            })}
          </DropdownMenu>
        </Dropdown>
      </div>
      {!isWebview && (
        <TooltipNew
          id="job-analaysis-1"
          event="hover"
          tooltipBgClx="bg-purple-800"
          tooltipClx="Body2-14Md !max-w-none rounded-[8px] p-[12px] drop-shadow-[0_2px_8px_rgba(0,0,0,0.2)]"
        >
          {t(n_ai_analysis.side_menu_tooltip)}
        </TooltipNew>
      )}
      {/* 국내/외국계 */}
      <div id="job-analaysis-2" onClick={clickHandler}>
        <Dropdown
          className="max-w-[120px]"
          disabled
          selected={option3}
          setSelected={setOption3}
          size={DROPDOWN_SIZE.LG}
        >
          <DropdownButton inactive>{t(n_ai_analysis.job_seg_popup.dropdown2)}</DropdownButton>
          <DropdownMenu>
            {getTransformForDropdown(options.job_type).map((item, i) => {
              return (
                <DropdownMenuItem key={i} value={item.id}>
                  {item.label}
                </DropdownMenuItem>
              )
            })}
          </DropdownMenu>
        </Dropdown>
      </div>
      {!isWebview && (
        <TooltipNew
          id="job-analaysis-2"
          event="hover"
          tooltipBgClx="bg-purple-800"
          tooltipClx="Body2-14Md !max-w-none rounded-[8px] p-[12px] drop-shadow-[0_2px_8px_rgba(0,0,0,0.2)]"
        >
          {t(n_ai_analysis.side_menu_tooltip)}
        </TooltipNew>
      )}
    </div>
  )
}

export default JobFilterSection
